
  import { Component } from 'vue-property-decorator'
  import PTitle from '@/components/config/PTitle.vue'
  import PSubtitle from '../PSubtitle.vue'
  import GCostField from '@/components/core/input/GCostField.vue'
  import { GenioView } from './GenioView'
  import { Process } from '@/entities/settings'

@Component({
  components: {
    PTitle,
    PSubtitle,
    GCostField,
  },
})
  export default class ConfigGoals extends GenioView {
  valid = true
  allProcess= []

  // Se definen todos los campos que se verán en el formulario
  formData = {
    profit: 0,
    ownStock: 0,
    credits: 0,
    leads: 0,
    purchaseAppraisals: 0,
    consignmentAppraisals: 0,
    purchaseInspections: 0,
    consignmentInspections: 0,
    purchaseNegotiations: 0,
    consignmentNegotiations: 0,
    purchases: 0,
    businessConsignments: 0,
    approvedCredits: 0,
    signedCredits: 0,
    reservations: 0,
    sales: 0,
    yardCapacity: 0,
    cashCapacity: 0,
    workingCapital: 0,
  }

  async mounted () {
    const process = await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { config: { _is_null: false } },
    })
    this.allProcess = process
    const stockProcess = process.find((p: Process) => p.tableName === 'stock')

    this.formData.workingCapital = stockProcess.config.resource.capital
    this.formData.yardCapacity = stockProcess.config.resource.capacity

    const inspectionProcess = process.find((p: Process) => p.tableName === 'inspection')
    this.formData.purchaseInspections = inspectionProcess.config.projectedUtility.quantity
    this.formData.consignmentInspections = inspectionProcess.config.projectedUtility.consignment

    const purchaseProcess = process.find((p: Process) => p.tableName === 'purchase_order')
    this.formData.purchases = purchaseProcess.config.projectedUtility.quantity
    this.formData.businessConsignments = purchaseProcess.config.projectedUtility.consignment

    const evaluationProcess = process.find((p: Process) => p.tableName === 'evaluation')
    this.formData.approvedCredits = evaluationProcess.config.projectedUtility.approved
    this.formData.signedCredits = evaluationProcess.config.projectedUtility.quantity
    this.formData.credits = evaluationProcess.config.projectedUtility.amount

    const saleOrderProcess = process.find((p: Process) => p.tableName === 'sale_order')
    this.formData.sales = saleOrderProcess.config.projectedUtility.quantity
    this.formData.ownStock = saleOrderProcess.config.projectedUtility.amount

    this.setProcessQuantity('lead', 'leads')
    this.setProcessQuantity('reserve', 'reservations')
    this.setAppraisalAndNegotiation()
  }

  setAppraisalAndNegotiation () {
    const { allProcess } = this

    const negotiationProcess = allProcess.find((p: Process) => p.tableName === 'negotiation')
    this.formData.purchaseNegotiations = negotiationProcess.config.projectedUtility.purchase
    this.formData.consignmentNegotiations = negotiationProcess.config.projectedUtility.consignment

    const appraisalProcess = allProcess.find((p: Process) => p.tableName === 'appraisal')
    this.formData.purchaseAppraisals = appraisalProcess.config.projectedUtility.purchase
    this.formData.consignmentAppraisals = appraisalProcess.config.projectedUtility.consignment
  }

  setProcessQuantity (processName, field) {
    const process = this.allProcess.find((p: Process) => p.tableName === processName)
    if (process) {
      this.formData[field] = process.config.projectedUtility.quantity
    }
  }

  async updateStock () {
    const stockProcess = this.allProcess.find((p: Process) => p.tableName === 'stock')
    const fields = {
      id: stockProcess.id,
      config: {
        ...stockProcess.config,
        resource: {
          ...stockProcess.config.resource,
          capital: parseInt(this.formData.workingCapital.toString()),
          capacity: parseInt(this.formData.yardCapacity.toString()),
        },
      },
    }
    await this.updateProcess(fields)
  }

  async updateLead () {
    const leadProcess = this.allProcess.find((p: Process) => p.tableName === 'lead')
    const fields = {
      id: leadProcess.id,
      config: {
        ...leadProcess.config,
        projectedUtility: {
          ...leadProcess.config.projectedUtility,
          quantity: parseInt(this.formData.leads.toString()),
        },
      },
    }
    await this.updateProcess(fields)
  }

  async updateAppraisal () {
    const appraisalProcess = this.allProcess.find((p: Process) => p.tableName === 'appraisal')
    const fields = {
      id: appraisalProcess.id,
      config: {
        ...appraisalProcess.config,
        projectedUtility: {
          ...appraisalProcess.config.projectedUtility,
          purchase: parseInt(this.formData.purchaseAppraisals.toString()),
          consignment: parseInt(this.formData.consignmentAppraisals.toString()),
        },
      },
    }
    await this.updateProcess(fields)
  }

  async updateInspection () {
    const inspectionProcess = this.allProcess.find((p: Process) => p.tableName === 'inspection')
    const fields = {
      id: inspectionProcess.id,
      config: {
        ...inspectionProcess.config,
        projectedUtility: {
          ...inspectionProcess.config.projectedUtility,
          quantity: parseInt(this.formData.purchaseInspections.toString()),
          consignment: parseInt(this.formData.consignmentInspections.toString()),
        },
      },
    }
    await this.updateProcess(fields)
  }

  async updateNegotiation () {
    const negotiationProcess = this.allProcess.find((p: Process) => p.tableName === 'negotiation')
    const fields = {
      id: negotiationProcess.id,
      config: {
        ...negotiationProcess.config,
        projectedUtility: {
          ...negotiationProcess.config.projectedUtility,
          purchase: parseInt(this.formData.purchaseNegotiations.toString()),
          consignment: parseInt(this.formData.consignmentNegotiations.toString()),
        },
      },
    }
    await this.updateProcess(fields)
  }

  async updatePurchase () {
    const purchaseProcess = this.allProcess.find((p: Process) => p.tableName === 'purchase_order')
    const fields = {
      id: purchaseProcess.id,
      config: {
        ...purchaseProcess.config,
        projectedUtility: {
          ...purchaseProcess.config.projectedUtility,
          quantity: parseInt(this.formData.purchases.toString()),
          consignment: parseInt(this.formData.businessConsignments.toString()),
        },
      },
    }
    await this.updateProcess(fields)
  }

  async updateEvaluation () {
    const evaluationProcess = this.allProcess.find((p: Process) => p.tableName === 'evaluation')
    const fields = {
      id: evaluationProcess.id,
      config: {
        ...evaluationProcess.config,
        projectedUtility: {
          ...evaluationProcess.config.projectedUtility,
          approved: parseInt(this.formData.approvedCredits.toString()),
          quantity: parseInt(this.formData.signedCredits.toString()),
          amount: parseInt(this.formData.credits.toString()),
        },
      },
    }
    await this.updateProcess(fields)
  }

  async updateSaleOrder () {
    const saleOrderProcess = this.allProcess.find((p: Process) => p.tableName === 'sale_order')
    const fields = {
      id: saleOrderProcess.id,
      config: {
        ...saleOrderProcess.config,
        projectedUtility: {
          ...saleOrderProcess.config.projectedUtility,
          quantity: parseInt(this.formData.sales.toString()),
          amount: parseInt(this.formData.ownStock.toString()),
        },
      },
    }
    await this.updateProcess(fields)
  }

  async updateReserve () {
    const reserveProcess = this.allProcess.find((p: Process) => p.tableName === 'reserve')
    const fields = {
      id: reserveProcess.id,
      config: {
        ...reserveProcess.config,
        projectedUtility: {
          ...reserveProcess.config.projectedUtility,
          quantity: parseInt(this.formData.reservations.toString()),
        },
      },
    }
    await this.updateProcess(fields)
  }

  async save () {
    // Valida el formulario antes de guardar
    if (!(this.$refs.form as any).validate()) {
      await this.setFieldError()
      return
    }

    await this.updateStock()
    await this.updateLead()
    await this.updateAppraisal()
    await this.updateInspection()
    await this.updateNegotiation()
    await this.updatePurchase()
    await this.updateEvaluation()
    await this.updateSaleOrder()
    await this.updateReserve()
    this.$emit('update', this.formData)
  }
  }
